import { Play, Clock, CheckCircle } from "lucide-react"

interface StatusBadgeProps {
  status: string
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = {
    live: { icon: Play, color: "text-green-400 border-green-600", label: "Live" },
    upcoming: { icon: Clock, color: "text-amber-400 border-amber-600", label: "Upcoming" },
    completed: { icon: CheckCircle, color: "text-gray-400 border-gray-600", label: "Completed" },
  }[status] || { icon: Clock, color: "text-gray-400 border-gray-600", label: "Unknown" }

  const Icon = config.icon
  return (
    <div
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium border ${config.color}`}
    >
      <Icon className="h-3 w-3" />
      {config.label}
    </div>
  )
} 